import { Component } from '@angular/core';
import { CardModule } from 'primeng/card';
import { PanelModule } from 'primeng/panel';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-about-torna',
  standalone: true,
  imports: [CommonModule, CardModule, PanelModule],
  template: `
    <div class="p-6 flex justify-center">
      <div class="w-full max-w-11xl">
        <p-card header="About Torna Sales Portal" class="p-6 text-lg leading-relaxed">
          
          <!-- Flex Row for Logo + Intro Text -->
          <div class="flex items-center gap-6 mb-6">
            <!-- Logo -->
            <div class="flex-shrink-0">
              <img 
                src="assets/torna_logo.png" 
                alt="Torna Logo" 
                class="torna-logo torna-logo--about"
              >
            </div>

            <!-- Text beside logo -->
            <div class="flex-1">
              <p>
                The <strong>GFT Torna Sales Portal</strong> is a customized web-based solution 
                built exclusively for the <strong>GFT Sales Team</strong> to streamline, digitize, 
                and simplify the complete sales order entry and management lifecycle. 
                It serves as a bridge between the Sales Team and the <strong>Infor M3 ERP</strong>, 
                ensuring faster, more accurate order processing, real-time monitoring, 
                and greater visibility of operations.
              </p>
            </div>
          </div>

          <!-- Summary -->
          <h3 class="mt-4">Summary</h3>
          <p>
            The Torna Sales Portal has been designed as a <strong>two-tier solution</strong>
            where Torna functions as the front-end application for sales teams and managers,
            while <strong>M3 ERP</strong> acts as the back-end system of record. Torna allows
            salespeople to place customer orders (COs), manage line items, and make
            modifications in a simplified environment without needing to interact directly
            with M3.
          </p>
          <p>
            At its core, Torna enables <strong>two levels of user interaction</strong>:
          </p>
          <ul class="list-disc list-inside">
            <li>
              <strong>Sales Persons</strong> – Can create, view, and edit their own
              customer orders, track progress, and monitor their targets vs. achievements
              through an interactive dashboard.
            </li>
            <li>
              <strong>Sales Managers</strong> – Have global visibility across all orders
              and KPIs, with authority to review, validate, adjust, or substitute line
              items, manage shortages, apply discounts, and synchronize the approved
              orders into the M3 ERP system for further processing.
            </li>
          </ul>
          <p>
            Orders entered in Torna are initially stored at a draft status (<strong>Status 10</strong>),
            ensuring they remain outside M3 until reviewed and confirmed. Once approved and
            pushed to <strong>M3</strong>, orders follow defined workflows like dispatch,
            delivery, stock adjustments, invoicing, and reporting.
          </p>
          <p>
            In summary, Torna acts as the <strong>dedicated digital sales front-end</strong>
            for GFT, delivering faster and more accurate customer order management, flexible
            shortage handling, simplified invoicing, and seamless integration with
            <strong>Infor M3 ERP</strong>.
          </p>

          <!-- Key Features -->
          <h3 class="mt-4">Key Features</h3>
          <ul class="list-disc list-inside">
            <li>Secure login & user profile management</li>
            <li>User dashboard with targets & achievements</li>
            <li>Order creation, editing, and real-time tracking</li>
            <li>Automated calculations for pricing, discounts, and VAT</li>
            <li>Sync with Infor M3 for backend processing</li>
            <li>Generate  Invoices & Picking Lists</li>
            <li>Performance monitoring through dashboards</li>
          </ul>

          <!-- Benefits -->
          <h3 class="mt-4">Benefits</h3>
          <ul class="list-disc list-inside mb-8">
            <li>User-friendly centralized interface</li>
            <li>Faster, more accurate order processing</li>
            <li>Real-time sales insights and visibility</li>
            <li>Alignment with GFT workflows for efficiency</li>
            <li>Optimized digital sales operations</li>
          </ul>

          <!-- Footer -->
          <div class="border-t pt-4 text-center text-sm text-gray-600">
            Designed & Developed by 
            <strong>SSK Technologies</strong> |
            <a href="https://www.linkedin.com/company/ssktechpl" 
               target="_blank" 
               class="text-blue-600 hover:underline">
               LinkedIn
            </a> |
            <a href="https://ssktech.co.in/" 
               target="_blank" 
               class="text-blue-600 hover:underline">
               Website
            </a>
          </div>
        </p-card>
      </div>
    </div>
  `,
  styles: [`
    @media (max-width: 768px) {
      .flex {
        flex-direction: column;
      }
      img {
        margin-bottom: 1rem;
      }
    }
  `]
})
export class AboutTornaComponent {}
